// extracted by mini-css-extract-plugin
export default {"wrapper":"TextWithDash_wrapper__zovjC","text":"TextWithDash_text__+ZBid","left":"TextWithDash_left__BYTG6","right":"TextWithDash_right__XHmnQ","gray":"TextWithDash_gray__okH5x"};